/* eslint-disable */
import register from '../register';
import dom from './util/dom';
import cookie from './util/cookie';
import jump from './util/jump';
import phoneMask from './util/phone-mask';

let $ = document.querySelector.bind( document );
let $$ = document.querySelectorAll.bind( document );

var validators = {
  email: validateEmail,
  phone: validatePhone
};

var utmKeys = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
];

class mduReferForm {

  constructor( context ) {
    this.form = context.querySelector('.form-mdu-refer');
    this.formBody = context.querySelector('.mdu-form-body');
    this.inputs = Array.prototype.slice.call(
      this.form.querySelectorAll('input:not([type="radio"]), select')
    );

    this.success = context.querySelector('.mdu-form-success');
    this.checkmark = context.querySelector('.success-checkmark');

    this.phone = this.form.querySelector('.inp-phone');
    this.suggestions = this.form.querySelector('.mdu-suggestions');
    this.market = this.form.querySelector('.inp-market');
    this.marketText = this.form.querySelector('.inp-market-text');
    this.marketTextRow = this.form.querySelector('.row.market-text');

    this.street_number = this.form.querySelector('.hidden-street-number');
    this.street = this.form.querySelector('.hidden-street');
    this.city = this.form.querySelector('.hidden-city');
    this.state = this.form.querySelector('.hidden-state');
    this.zip_code = this.form.querySelector('.hidden-zip-code');
    this.latitude = this.form.querySelector('.hidden-latitude');
    this.longitue = this.form.querySelector('.hidden-longitude');

    this.toggleMarketTextInput = this.toggleMarketTextInput.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getPayload = this.getPayload.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.onSuccess = this.onSuccess.bind(this);

    this.bindEvents();
    phoneMask( this.phone );
  }

  bindEvents() {
    this.form.addEventListener( 'submit', this.onSubmit, false );
    this.market.addEventListener( 'change', this.toggleMarketTextInput, false );
  }

  toggleMarketTextInput( e ) {
    let val = e.target.value.toLowerCase();
    let showTextInput = ( val === 'other' );

    if ( showTextInput ) {
      this.marketText.setAttribute( 'type', 'text' );
      this.marketText.setAttribute( 'data-validate', '' );
      this.marketText.value = '';
      this.marketTextRow.classList.remove('hidden');
    } else {
      this.marketText.setAttribute( 'type', 'hidden' );
      this.marketText.removeAttribute('data-validate');
      this.marketTextRow.classList.add('hidden');
      this.marketText.value = val;
    }
  }

  onSubmit( e ) {
    let payload;
    e.preventDefault();

    if( this.validate() ) {
      payload = Object.assign( this.getPayload(), getAnalyticsData() );
      this.submitForm( payload );
    }
  }

  validate() {
    return !this.inputs
    .filter( shouldValidate )
    .map( removeError )
    .filter( isInvalid )
    .map( addError ).length;
  }

  getPayload() {
    return this.inputs
    .filter( isNotSubmit )
    .reduce( inputReducer, {} );
  }

  submitForm( payload ) {
    dom.ajax(
      {
        url: '/referrals',
        method: 'POST',
      },
      payload,
      ( err, res ) => {
        if ( err ) {
          return;
        }
        acumen.track(
          'web-submit-building_owner',
          {
            first_name: payload.first_name,
            last_name: payload.last_name,
            phone: payload.phone,
            email: payload.email_address,
            role: payload.role,
            campaign: payload.campaign,
            personality: payload.personality,
            market: payload.market
          }
        );
        acumen.identify({ email: payload.email_address });
        this.onSuccess( res );
      }
    );
  }

  onSuccess( res ) {
    this.success.style.display = 'block';
    this.formBody.style.display = 'none';
    jump( this.success, {
      duration: 300,
      offset: -100,
      callback: () => this.checkmark.classList.add('animated')
    });
  }

}

function init() {
  let contexts = document.querySelectorAll('.mdu-form-section');
  contexts.forEach( context => new mduReferForm( context ) );
}

function validateZip( str ) {
  return /^\d{5}(?:[-\s]\d{4})?$/.test( str );
}

function validateEmail( str ) {
  return /\S+@\S+/.test( str );
}

function validatePhone( str ) {
  if ( str.length > 0 ) {
    return ( str.match(/\d/g) || [] ).length === 10;
  }
  return false;
}

function addError( inp ) {
  var parent = inp.parentNode;
  parent.classList.add('error');
  return inp;
}

function removeError( inp ) {
  var parent = inp.parentNode;
  parent.classList.remove('error');
  return inp;
}

function shouldValidate( inp ) {
  return inp.dataset.validate !== undefined;
}

function isEmpty( inp ) {
  return !inp.value || inp.value === 'none';
}

function isInvalid( inp ) {
  var validate = validators[ inp.dataset.validate ];
  return typeof validate === 'function' ?
    !validate( inp.value ) : isEmpty( inp );
}

function isNotSubmit( inp ) {
  return inp.type !== 'submit';
}

function inputReducer( obj, inp ) {
  obj[ inp.name ] = inp.type === 'checkbox' ? inp.checked : ( inp.value || null );
  return obj;
}

function getAnalyticsData() {
  return utmKeys.reduce(function( output, key ) {
    var val = cookie.getItem( key );
    if ( val !== null ) {
      output[ key ] = val;
    }
    return output;
  }, {} );
}

register( 'mdu-refer', init );
